import React from 'react'
import { Box, Grid, Typography } from '@mui/material';

const TechRsltDetailView = ({ techRslt }) => {
  return (
    <Box sx={{ mt: 1, px: 2 }}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">결과보고서 상태</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {techRslt?.rsltStatus === 'S' && ('결재 진행중')}
              {techRslt?.rsltStatus === 'Y' && ('사용중')}
              {techRslt?.rsltStatus === 'N' && ('미사용')}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div"> 결과보고서 종류</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">{techRslt?.rsltTyp}</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">결과보고서명</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography variant="body2" component="div">{techRslt?.rsltTitle}</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">작업 시작일시</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div">{techRslt?.rsltStrtDt}~{techRslt?.rsltStrtTm}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">작업 종료일시</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div"> {techRslt?.rsltEndDt}~{techRslt?.rsltEndTm}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">총 작업시간</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2" component="div"> {techRslt?.rsltTotTm} 시간</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div" >참고사항</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{techRslt?.rsltContext}</Typography>
          </Grid>

        </Grid>
      </Grid>
    </Box>
  )
}

export default TechRsltDetailView